import Keycloak from 'keycloak-js';

export const getKeycloakInstance = () => new Keycloak({
  realm: process.env.GATSBY_KEYCLOAK_REALM,
  url: process.env.GATSBY_KEYCLOAK_URL,
  clientId: process.env.GATSBY_KEYCLOAK_CLIENT_ID,
});
